/* global axios */

import ApiClient from '../ApiClient';

class LixFollowAPI extends ApiClient {
  constructor() {
    super('integrations/lixfollow', { accountScoped: true });
  }

  show() {
    return axios.get(this.url);
  }

  update(data) {
    return axios.patch(this.url, data);
  }

  testConnection() {
    return axios.post(`${this.url}/test_connection`);
  }
}

export default new LixFollowAPI();
